/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 */

// 3rd Party
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

// Components
import {
  Div,
  FlexCol,
  H1,
  MarketingButton,
  P,
} from 'common/styles/oc-styled-components';

// Other
import { colors } from 'common/styles/style-constants';
import { useRedirectionService } from 'services/RedirectionService';

import CONFIG from '../../../app.config';

import messages from './messages';

// Component
export default function NotFound() {
  const redirectionService = useRedirectionService();

  const goToHomepage = useCallback(() => {
    redirectionService.redirect({
      url: CONFIG.SEARCH_APP_URL,
      reason: 'not-found-go-to-homepage',
    });
  });

  return (
    <main>
      <Div padding="10px" background={colors.nickel}>
        <FlexCol align="center" justify="center" height="100vh">
          <H1 textAlign="center">
            <FormattedMessage {...messages.header} />
          </H1>
          <P fontSize="18px">
            <FormattedMessage {...messages.copy} />
          </P>
          <MarketingButton
            type="primary"
            size="large"
            shape="round"
            margin="25px 0 0 0"
            onClick={goToHomepage}
          >
            <FormattedMessage {...messages.button} />
          </MarketingButton>
        </FlexCol>
      </Div>
    </main>
  );
}
